import {
  columnSchema as pharmacyColumnSchema,
  columnDetails as pharmacyColumnDetails,
  columnNameAliases as pharmacyColumnNameAliases,
  computedColumns as pharmacyComputedColumns,
  tableHeaders as pharmacyTableHeaders,
  sortedColumnDetails as pharmacySortedColumnDetails,
} from "./PharmacyClaim";

import {
  columnSchema as medicalColumnSchema,
  columnDetails as medicalColumnDetails,
  columnNameAliases as medicalColumnNameAliases,
  computedColumns as medicalComputedColumns,
  tableHeaders as medicalTableHeaders,
  sortedColumnDetails as medicalSortedColumnDetails,
} from "./MedicalClaim";

import {
  columnSchema as pharmacyEncounterColumnSchema,
  columnDetails as pharmacyEncounterColumnDetails,
  columnNameAliases as pharmacyEncounterColumnNameAliases,
  computedColumns as pharmacyEncounterComputedColumns,
  tableHeaders as pharmacyEncounterTableHeaders,
  sortedColumnDetails as pharmacyEncounterSortedColumnDetails,
} from "./PharmacyEncounterClaim";

export const columnSchema = (kind) => {
  switch (kind) {
    case "pharmacy":
      return { ...pharmacyColumnSchema };
    case "medical":
      return { ...medicalColumnSchema };
    case "pharmacy_encounter":
      return { ...pharmacyEncounterColumnSchema };
    default:
      return {};
  }
};

export const columnDetails = (kind) => {
  switch (kind) {
    case "pharmacy":
      return pharmacySortedColumnDetails;
    case "medical":
      return medicalSortedColumnDetails;
    case "pharmacy_encounter":
      return pharmacyEncounterSortedColumnDetails;
    default:
      return [];
  }
};

export const tableHeaders = (kind) => {
  switch (kind) {
    case "pharmacy":
      return pharmacyTableHeaders;
    case "medical":
      return medicalTableHeaders;
    case "pharmacy_encounter":
      return pharmacyEncounterTableHeaders;
    default:
      return [];
  }
};

export const columnNameAliases = (kind) => {
  switch (kind) {
    case "pharmacy":
      return pharmacyColumnNameAliases;
    case "medical":
      return medicalColumnNameAliases;
    case "pharmacy_encounter":
      return pharmacyEncounterColumnNameAliases;
    default:
      return {};
  }
};

export const computedColumns = (kind) => {
  switch (kind) {
    case "pharmacy":
      return pharmacyComputedColumns;
    case "medical":
      return medicalComputedColumns;
    case "pharmacy_encounter":
      return pharmacyEncounterComputedColumns;
    default:
      return [];
  }
};
